import * as Sentry from '@sentry/angular-ivy';

// Imported first in main.ts so the SDK installs before Angular bootstraps.
const sentryDsn = process.env.SENTRY_DSN;

Sentry.init({
  dsn: sentryDsn,
  // Unset outside production, where the SDK falls back to "production".
  environment: process.env.SENTRY_ENVIRONMENT,
  // Must match the release scripts/sentry-upload.js uploads under.
  release: process.env.SENTRY_RELEASE,
  enabled: !!sentryDsn,
});
